import React from 'react';

export const TEST_VERSION_NOTICE_TEXT = '当前版本为测试版本，供大家免费使用';

type TestVersionNoticeProps = {
  /** auth：登录/注册卡片内；header：MobileApp 顶栏中间 */
  variant?: 'auth' | 'header';
  className?: string;
};

export const TestVersionNotice: React.FC<TestVersionNoticeProps> = ({
  variant = 'auth',
  className
}) => {
  const style: React.CSSProperties =
    variant === 'header'
      ? {
          margin: 0,
          fontSize: 11,
          color: '#c62828',
          fontWeight: 500,
          textAlign: 'center',
          lineHeight: 1.35,
          padding: '0 6px',
          width: '100%',
          maxWidth: '100%'
        }
      : {
          margin: '0 0 10px 0',
          fontSize: 12,
          color: '#c62828',
          fontWeight: 500,
          textAlign: 'center',
          lineHeight: 1.4,
          padding: '0 8px',
          width: '100%'
        };

  return (
    <p className={className} style={style}>
      {TEST_VERSION_NOTICE_TEXT}
    </p>
  );
};
